class CarouselFeature extends EventTarget {
  constructor(host) {
    super();
    this.host = host;
    this.micro = this.host.micro;
  }
  // Do not delete these.
  connectedCallback() {
  }
  disconnectedCallback() {
  }
  attributeChangedCallback(name, oldValue, newValue) {
  }
}
CarouselFeature.observedAttributes = [];
export {
  CarouselFeature
};
